import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui/layout/layout';
import { Tooltip } from '@/components/ui/Tooltip';

const TRUSTED_INFO =
  "Trusted people's agents can talk to your agent without asking you first.";

export const TrustedHead = () => (
  <XStack className="items-center gap-1.5 whitespace-nowrap">
    Trusted
    <Tooltip
      label={TRUSTED_INFO}
      side="top"
      delayDuration={200}
      className="max-w-[16rem] whitespace-normal"
    >
      <span
        tabIndex={0}
        aria-label={TRUSTED_INFO}
        className="flex cursor-default rounded-full text-foreground-subtle hover:text-foreground-muted"
      >
        <Icons.info className="size-3.5" />
      </span>
    </Tooltip>
  </XStack>
);
